module.exports = __webpack_public_path__ + "img/wp-existing-habit-card4.0161a0c9.jpg";